export function isValidBlob(str: any) {
  return str instanceof Blob;
}
